import React from 'react';
import { Box, Image, Heading } from '@chakra-ui/react';
import ClientShare2x from 'images/client-share@2x.png';
import Share from 'images/share-hp.svg';

const ClientShare = () => {
  return (
    <Box
      className='share-section'
      px={['24px', '24px', '24px', '0px']}
      mt='320px'
    >
      <Box
        justifyContent='center'
        display='flex'
        alignItems='center'
        position='relative'
        height={['600px', '600px', '700px', '830px']}
      >
        <Image src={Share} alt='share' position='absolute' top='0' />
        <Image
          mx='auto'
          src={ClientShare2x}
          srcSet={`${ClientShare2x} 2x`}
          alt='client album'
          position='absolute'
          top='120px'
        />
      </Box>
      <Box>
        <Heading
          as='h3'
          fontSize='40px'
          color='white'
          fontWeight='bold'
          fontFamily='bold'
        >
          Designed for organic growth
        </Heading>
        <Box color='white' mt='24px' mx='auto' maxWidth='510px'>
          You can grow your brand when your clients share the albums with their
          friends and family
        </Box>
      </Box>
    </Box>
  );
};
export default ClientShare;
